import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/common/ErrorBoundary";
import "./assets/css/tailwind.css";
import "./utils/logger";
import "./assets/css/main.css";

// Disable React DevTools in production
if (process.env.NODE_ENV === 'production') {
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.isDisabled = true;
  }
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__ = undefined;
  Object.defineProperty(window, '__REACT_DEVTOOLS_GLOBAL_HOOK__', {
    configurable: false,
    value: undefined,
    writable: false
  });
}

// Error Boundary Component


// Create root and render App
const root = ReactDOM.createRoot(document.getElementById("root"));

// Strict Mode removed to avoid React Router UNSAFE_componentWillMount warnings
// Re-enable if needed for development debugging: <React.StrictMode>...</React.StrictMode>
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
